import React from 'react';

import { MCText, View } from 'src/components/basic';
import { TreatmentList } from 'src/components/user/Treatments';
import LANG_CONST from 'src/helpers/lang/const';
import { remCss } from '../utils';

export const TreatmentsTab = ({ clinic, currency, contentStyle }) => {
  const ref = React.useRef(null);
  return (
    <>
      <View
        data-testid={'public-treatments-tab'}
        ref={ref}
        style={{
          ...contentStyle
        }}
      >
        <MCText
          label={LANG_CONST.titles.treatments}
          size={26}
          weight={600}
          heading
          style={{ marginBottom: remCss(39) }}
        />
        <TreatmentList
          treatments={clinic?.treatments || []}
          onPage={() => {
            ref.current.scrollIntoView({ behavior: 'smooth' });
          }}
          currency={currency}
        />
      </View>
    </>
  );
};
